import { setPath, slugOf } from "../ui/route.ts";

// The slug in the address bar, or null on the set list.
export interface Router {
  current(): string | null;
  go(slug: string | null, title: string | null, replace: boolean): void;
  listen(changed: (slug: string | null) => void): () => void;
}

const TITLE = "ankh";

export const browserRouter: Router = {
  current: () => slugOf(location.pathname),
  go(slug, title, replace) {
    document.title = title === null ? TITLE : `${title} · ${TITLE}`;
    const path = slug === null ? "/" : setPath(slug);
    if (path === location.pathname) return;
    if (replace) history.replaceState(null, "", path);
    else history.pushState(null, "", path);
  },
  listen(changed) {
    const pop = () => changed(slugOf(location.pathname));
    addEventListener("popstate", pop);
    return () => removeEventListener("popstate", pop);
  },
};

// The storybook's router: stories share one page, so the address bar stays put.
export const noRouter: Router = {
  current: () => null,
  go: () => {},
  listen: () => () => {},
};
